/* eslint-disable */
import React, { useContext } from 'react';
import { useTheme } from '@emotion/react';
import { StyleSheet, css } from 'aphrodite';
import PropTypes from 'prop-types';
import { ThemeContext } from '../../theme';

const propTypes = {
  text: PropTypes.string,
  isChecked: PropTypes.bool,
  isIndeterminate: PropTypes.bool,
  isDisabled: PropTypes.bool,
  onChange: PropTypes.func
};

const defaultProps = {
  text: 'Checkbox',
  isChecked: false,
  isIndeterminate: false,
  isDisabled: false,
  height: 18,
  width: 18,
};

const Checkbox = (props) => {
  const { isChecked, isIndeterminate, isDisabled, text } = props;
  const theme = useTheme();
  const context = useContext(ThemeContext);
  let checkbox;
  if (theme && theme.checkbox) {
    checkbox = theme.checkbox;
  } else {
    checkbox = context.theme.checkbox;
  }
  // const { theme } = context;
  // const { checkbox } = theme;
  const {
    isHandOnHover,
    checkboxBorderRadius,
    checkboxColor,
    checkboxBackground,
    checkboxHoverColor,
    checkboxCheckedColor,
    checkboxCheckedBackground,
    checkboxCheckedTickColor,
    checkboxIndeterminateColor,
    checkboxIndeterminateBackground,
    checkboxIndterminateTickColor,
    checkboxDisabledColor,
    checkboxDisabledBackground,
    checkboxDisabledTickColor
  } = checkbox;

  const styles = StyleSheet.create({
    labelStyles: {
      zIndex: '0',
      position: 'relative',
      display: 'inline-block',
      lineHeight: '1.5',
      color: checkboxColor,
      ':hover': {
        color: checkboxHoverColor
      }
    },
    checkedLabelStyles: {
      color: checkboxCheckedColor
    },
    indeterminateLabelStyles: {
      color: checkboxIndeterminateColor
    },
    disabledLabelStyles: {
      color: checkboxDisabledColor
    },
    inputStyles: {
      appearance: 'none',
      zIndex: '-1',
      position: 'absolute',
      left: '-10px',
      top: '-8px',
      display: 'block',
      margin: '0',
      borderRadius: '50%',
      width: '40px',
      height: '40px',
      boxShadow: 'none',
      outline: 'none',
      opacity: '0',
      transform: 'scale(0.8)',
      pointerEvents: 'none',
      transition: 'opacity 0.3s, transform 0.2s',
      ':checked': {
        background: 'red'
      },
      ':indeterminate': {
        background: 'red'
      }
    },
    spanStyles: {
      display: 'inline-block',
      width: '100%',
      cursor: isHandOnHover ? 'pointer' : 'inherit',
      // Box
      ':before': {
        content: "''",
        display: 'inline-block',
        boxSizing: 'border-box',
        margin: props.height === 18 ? '3px 8px 3px 0px' : '4px 8px 3px 0px',
        borderRadius: checkboxBorderRadius,
        border: 'solid 2px', /* Safari */
        width: `${props.width}px`,
        height: `${props.height}px`,
        verticalAlign: 'top',
        transition: 'border-color 0.2s, background-color 0.2s',
        borderColor: 'currentColor',
        background: 'transparent'
      },
      // Tick mark
      ':after': {
        content: "''",
        display: 'block',
        position: 'absolute',
        top: isIndeterminate ? '4px' : '3px',
        left: '0px',
        width: isIndeterminate ? ' 10px' : '12px',
        height: '7px',
        border: `solid ${isIndeterminate ? '10px' : '3px'} transparent`,
        borderRight: 'none',
        borderTop: 'none',
        borderColor: '',
        borderLeft: '',
        transform: isIndeterminate ? 'translate(4px, 3px)' : 'translate(3px, 4px) rotate(-45deg)'
      }
    },
    checkedSpanStyles: {
      color: checkboxCheckedColor,
      ':before': {
        borderColor: checkboxCheckedBackground,
        background: checkboxCheckedBackground
      },
      ':after': {
        borderColor: checkboxCheckedTickColor,
      }
    },
    indeterminateSpanStyles: {
      color: checkboxIndeterminateColor,
      ':before': {
        // borderWidth: '1px',
        borderColor: checkboxIndeterminateBackground,
        background: 'transparent'
      },
      ':after': {
        borderColor: checkboxIndterminateTickColor,
        borderLeft: 'none'
      }
    },
    disabledSpanStyles: {
      color: checkboxDisabledColor,
      cursor: 'not-allowed',
      // Box
      ':before': {
        borderColor: checkboxDisabledBackground,
        background: (isChecked) ? checkboxDisabledBackground : 'transparent'
      },
      // Tick mark
      ':after': {
        // borderColor: 'magenta'
        borderColor: (isChecked || isIndeterminate) ? checkboxDisabledTickColor : 'transparent',
        borderLeft: isIndeterminate ? 'none' : '',
      }
    }
  });

  return (
    <label
      className={css(
        styles.labelStyles,
        isChecked && styles.checkedLabelStyles,
        isIndeterminate && styles.indeterminateLabelStyles,
        isDisabled && styles.disabledLabelStyles
      )}
    >
      <input
        type="checkbox"
        onChange={props.onChange}
        className={css(styles.inputStyles)}
        checked={isChecked}
        indeterminate={isIndeterminate ? true : undefined}
      />
      <span
        className={css(
          styles.spanStyles,
          isChecked && styles.checkedSpanStyles,
          isIndeterminate && styles.indeterminateSpanStyles,
          isDisabled && styles.disabledSpanStyles
        )}
      >
        {text}
      </span>
    </label>
  );
};

Checkbox.propTypes = propTypes;
Checkbox.defaultProps = defaultProps;
export { Checkbox };
